import CardSkeleton from "../loader/skeleton/cardSkeleton";
import NoMachineAvailable from "../home/noMachineAvailable";
import WatchListCard from "../home/card/watchListCard";

const WatchListMachineList = ({ isLoading, machineData, handelReload }) => {
  return (
    <>
      <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {isLoading ? (
          [1, 2, 3, 4, 5, 6, 7, 8, 9].map(() => {
            return <CardSkeleton />;
          })
        ) : machineData?.length <= 0 ? (
          <div className="h-[500px] flex items-center justify-center max-[1196px]:col-span-2 max-[842px]:col-span-1 col-span-3">
            <NoMachineAvailable />
          </div>
        ) : (
          machineData.map((item) => {
            return <WatchListCard listCard={true} data={item} handelReload={handelReload} />;
          })
        )}
      </div>
    </>
  );
};
export default WatchListMachineList;
